
import { VRow } from "vuetify/lib";

export default VRow.extend({});
